/**
 * Created by Vladislav on 01.04.2025.
 */

const RoomView = cc.Node.extend({
    ctor: function (location) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.room = new Room(location);
        const room = this.room;
        this.hidden = false;
        this.topBorderHeight = 0;
        this.bottomBorderHeight = 0;

        this.bg = new cc.Sprite(bundles[room.getBundleId()].urls["background_jpg"]);

        this.items = [];
        this.repairs = {};
        this.effects = [];
        
        for (let index = 0; index < this.getItemsAmount(); index++) {
            const itemIndex = `item_${index === this.getItemsAmount() - 1 && room.location.isLastRoom() ? "soon" : index}`;
            const spine = new cleverapps.Spine(bundles[room.getBundleId()].jsons[itemIndex]);

            const parsedSlot = this.parseSlotName(spine);
            this.bg.addChild(spine, parsedSlot.zOrder);
            spine.setAnimation(0, `idle_${this.getItemStage(index)}`, true);
            spine.setAlignment(this.bg.width / 2, this.bg.height / 2);

            this.items[index] = spine;
            this.repairs[index] = parsedSlot.repairAnimation;
            this.effects[index] = parsedSlot.effect;
        }

        this.scrollContent = new cc.Node();
        this.scrollContent.setAnchorPoint(0.5, 0.5);
        this.scrollContent.addChild(this.bg);

        this.scroll = new cleverapps.UI.ScrollView(this.scrollContent, {
            childrenVisibility: false,
            inertialScrollFactor: 0.3,
            outOfBoundaryScale: false,
            scrollBarEnabled: false
        });
        this.scroll.setClippingEnabled(false);
        this.addChild(this.scroll);

        this.scroll.onUpdatePositionListener = () => {
            this.updateRepairPosition();
        };

        this.createRepairView();
        this.onAfterResize();
        this.updateRepairPosition();

        room.on("beforeNextStage", this.onBeforeNextStage.bind(this), this);
        room.on("afterNextStage", this.onAfterNextStage.bind(this), this);
        room.on("nextStage", this.onNextStage.bind(this), this);
        room.on("reset", this.onReset.bind(this), this);
        room.location.on("scrollToRepair", this.scrollToRepair.bind(this), this);
    },

    onExit: function () {
        this._super();

        this.room.destructor();
    },

    scrollToRepair: function (stage, f) {
        const scrollTarget = this.getSlot(stage);

        this.scroll.runAction(new cc.Sequence(
            new cc.ScrollAction(scrollTarget, {
                duration: 0.5,
                visibleBox: {
                    left: 0.6,
                    right: 0.6
                }
            }),
            new cc.CallFunc(f)
        ));
    },

    addBorders: function (bottomBorderHeight, topBorderHeight) {
        const bgSize = cleverapps.resolution.getBgSize();

        if (!this.topBorder) {
            this.topBorder = new cleverapps.Spine(bundles.merge.jsons.meta_border_json);
            this.topBorder.setAnchorPoint(0.5, 0);
            this.topBorder.setAnimation(0, "top", true);
            this.topBorder.setLocalZOrder(1000);
            this.addChild(this.topBorder);
        }

        if (!this.bottomBorder) {
            this.bottomBorder = new cleverapps.Spine(bundles.merge.jsons.meta_border_json);
            this.bottomBorder.setAnchorPoint(0.5, 1);
            this.bottomBorder.setAnimation(0, "bottom", true);
            this.bottomBorder.setLocalZOrder(1000);
            this.addChild(this.bottomBorder);
        }

        const extraHeight = cleverapps.styles.RoomView.borders.extraHeight;
        const bordersScale = Math.max(
            bgSize.width / this.bottomBorder.width,
            bottomBorderHeight / (this.bottomBorder.height - extraHeight * 2),
            topBorderHeight / (this.topBorder.height - extraHeight * 2)
        );
        this.topBorder.setScale(bordersScale);
        this.topBorder.setPosition(bgSize.width / 2, bgSize.height - topBorderHeight - extraHeight * bordersScale);

        this.bottomBorder.setScale(bordersScale);
        this.bottomBorder.setPosition(bgSize.width / 2, bottomBorderHeight + extraHeight * bordersScale);
    },

    removeBorders: function () {
        if (this.topBorder) {
            this.topBorder.removeFromParent();
            delete this.topBorder;
        }

        if (this.bottomBorder) {
            this.bottomBorder.removeFromParent();
            delete this.bottomBorder;
        }
    },

    show: function () {
        this.repairViewHiding && this.repairViewHiding.show(true);
        this.scroll.touchScrollDisabled = false;

        this.setHidden(false);
    },

    hide: function () {
        this.repairViewHiding && this.repairViewHiding.hide(true);
        this.scroll.touchScrollDisabled = true;

        this.setHidden(true);
    },

    setHidden: function (hidden) {
        if (hidden === this.hidden) {
            return;
        }

        this.hidden = hidden;

        this.bg.setVisible(!this.hidden);
    },

    parseSlotName: function (spine) {
        const keys = Object.keys(spine.slots);
        const prefix = "slot_item_";
        const defaultSlotData = {
            zOrder: 0,
            repairAnimation: "none",
            effect: "none"
        };

        const slotName = keys.find((name) => name.startsWith(prefix));
        if (!slotName) {
            console.error(`${spine.jsonName} Slot with prefix ${prefix} not found`);
            return defaultSlotData;
        }

        const parts = slotName.split("_");
        if (parts.length < 4) {
            console.error(`${spine.jsonName} Invalid slot name format: expected "slot_item_[zOrder]_[repairAnimation]_[effect]", got ${slotName}`);
            return defaultSlotData;
        }

        const zOrder = parseInt(parts[2]) || 0;
        const repairAnimation = parts[3] || defaultSlotData.repairAnimation;
        const effect = parts[parts.length - 1] || defaultSlotData.effect;

        return { zOrder, repairAnimation, effect };
    },

    getItemsAmount: function () {
        return this.room.itemsAmount;
    },

    getCurrentItem: function (isPrevious) {
        return this.room.calcCurrentItem(isPrevious);
    },

    getItemStage: function (index) {
        return this.room.calcCurrentStage(index);
    },

    createRepairButton: function () {
        return new RoomRepairView(this.room);
    },

    createRepairView: function () {
        const location = this.room.location;
        if (location.isRoomCompleted() && !location.isLastRoom()) {
            return;
        }

        this.repairView = this.createRepairButton();

        this.repairViewControl = new cc.Node();
        this.repairViewControl.addChild(this.repairView);
        this.bg.addChild(this.repairViewControl, 100);

        this.repairViewHiding = ComponentMap.attach(this.repairViewControl, new HidingComponent({
            direction: HidingComponent.DIR.NONE
        }));
        this.repairViewHiding.show();
    },

    removeRepairView: function () {
        if (this.repairViewControl) {
            this.repairViewControl.removeFromParent();
            this.repairViewControl = undefined;
            this.repairViewHiding = undefined;
            this.repairView = undefined;
        }
    },

    getRepairView: function () {
        return this.repairViewControl;
    },

    getCurrentSlot: function () {
        return this.getSlot(this.getCurrentItem());
    },

    getSlot: function (stageNo) {
        return this.getSlotItem(this.items[Math.min(this.items.length - 1, stageNo)]);
    },

    getSlotItem: function (spine) {
        const keys = Object.keys(spine.slots);
        const slotName = keys.find((slotName) => slotName.includes("slot_item"));

        return spine.slots[slotName];
    },

    updateRepairPosition: function () {
        if (!this.repairView || this.repairView.inAnimation) {
            return;
        }

        const styles = cleverapps.styles.RoomView;

        const scene = cleverapps.Scenes.GetRunningScene();

        let slotPosition;

        if (this.room.location.isRoomCompleted()) {
            slotPosition = this.bg.convertToWorldSpace(cc.p(this.bg.width / 2, this.bg.height / 2));
        } else {
            const slot = this.getSlot(this.repairView.getStageNo());
            slotPosition = slot.convertToWorldSpace(cc.p(slot.width / 2, slot.height / 2));
        }

        let repairViewRect = this.repairViewControl.getGlobalBoundingBox();

        const padding = cc.padding(styles.repairView.padding);
        repairViewRect = cc.rectAddPadding(repairViewRect, padding);

        repairViewRect.x = slotPosition.x - repairViewRect.width / 2;
        repairViewRect.y = slotPosition.y - repairViewRect.height / 2;

        const avoidRects = [];

        ComponentUtils.findComponentByName(scene, "UpMenuController").listNodes().forEach((node) => {
            avoidRects.push(node.getGlobalBoundingBox());
        });

        const sideBar = ComponentUtils.findComponentByName(scene, "SideBarController");

        if (sideBar) {
            avoidRects.push(...sideBar.slots
                .filter((slot) => slot.isOccupied())
                .map((slot) => slot.getShowBoundingBox()));
        }

        const sceneComponent = ComponentMap.getByName(scene, "Merge2SceneComponent");

        if (sceneComponent && sceneComponent.progressView) {
            avoidRects.push(sceneComponent.progressView.getGlobalBoundingBox());
        }

        if (scene.arrows) {
            avoidRects.push(...scene.arrows.map((node) => node.getGlobalBoundingBox()));
        }

        if (sceneComponent && sceneComponent.switchButton) {
            avoidRects.push(sceneComponent.switchButton.getGlobalBoundingBox());
        }

        const toolbar = ComponentUtils.findChildByName(scene, "toolbar");

        if (toolbar && HidingComponent.isNodeShown(toolbar)) {
            avoidRects.push(toolbar.getGlobalBoundingBox());
        }

        const screenRect = scene.getGlobalBoundingBox();

        const targetRect = cleverapps.UI.findPlaceForRect(repairViewRect, screenRect, avoidRects);

        this.repairViewControl.setPosition(this.repairViewControl.parent.convertToNodeSpace(cc.p(
            targetRect.x + targetRect.width / 2,
            targetRect.y + targetRect.height / 2
        )));
    },

    onBeforeNextStage: function () {
        this.removeRepairView();
    },

    onAfterNextStage: function (waiter) {
        new ActionPlayer([
            (f) => {
                this.removeRepairView();
                this.createRepairView();
                this.updateRepairPosition();

                if (this.repairView) {
                    this.repairView.onAfterNextStage(f);
                } else {
                    f();
                }
            }
        ]).play(waiter());
    },

    onNextStage: function (f) {
        this.clickListener = cleverapps.UI.onClick(this, () => {
            this.stopAllActions();
        }, {
            interactiveScale: false
        });
        const focusState = cleverapps.focusManager.getState();
        cleverapps.focusManager.setEventNodes([this]);
        this.scroll.touchScrollDisabled = true;

        const currentItem = this.getCurrentItem(true);
        const currentStage = this.getItemStage(currentItem);

        const slot = this.getSlotItem(this.items[currentItem]);
        const slotPosition = this.bg.convertToNodeSpace(slot.parent.convertToWorldSpace(slot.getPosition()));

        const animationName = this.repairs[currentItem];
        let animation;
        let animationDuration = 0;

        if (animationName && animationName !== "none") {
            animation = new cleverapps.Spine(bundles.repair_animations.jsons[`room_${animationName}_json`]);
            this.bg.addChild(animation);
            animation.setLocalZOrder(100);

            animation.setAlignment(slotPosition);

            const effectName = this.effects[currentItem];

            if (effectName) {
                cleverapps.effects.fire(`location.garden.room.${effectName}`);
            } else {
                cleverapps.effects.fire(`location.garden.repair.stage.${currentItem}`);
            }
            animation.setAnimation(0, "animation", false);
            animation.setCompleteListenerRemove();

            animationDuration = animation.getAnimationDuration("animation");
        }

        const transitionName = `transition_${currentStage}`;
        const transitionAnimation = this.items[currentItem].hasAnimation(transitionName) ? transitionName : "transition";
        this.items[currentItem].setAnimationAndIdleAfter(transitionAnimation, `idle_${currentStage + 1}`);

        animationDuration = Math.max(animationDuration, this.items[currentItem].getAnimationDuration(transitionAnimation));

        const particles = new cleverapps.Spine(bundles.repair_animations.jsons.room_particle_json);
        particles.setLocalZOrder(100);
        this.bg.addChild(particles);
        particles.setAlignment(slotPosition);
        const particlesDuration = particles.getAnimationDuration("animation");

        cleverapps.audio.fadeOut(0.3);

        this.runAction(new cc.Sequence(
            new cc.DelayTime(animationDuration),
            new cc.CallFunc(
                () => {
                    cleverapps.effects.fire("location.garden.room.particles");
                    particles.setAnimation(0, "animation", false);
                    particles.setCompleteListenerRemove();
                }
            ),
            new cc.DelayTime(particlesDuration)

        )).setFinalize(() => {
            this.clickListener.remove();
            delete this.clickListener;
            this.scroll.touchScrollDisabled = false;

            cleverapps.audio.fadeIn(0.3);
            animation && animation.removeFromParent();
            particles.removeFromParent();
            this.items[currentItem].setAnimation(0, `idle_${currentStage + 1}`, true);

            if (cleverapps.focusManager.getState() !== focusState) {
                f();
                return;
            }

            cleverapps.focusManager.setEventNodes([]);
            this.showRepairDialogue(f);
        });
    },

    showRepairDialogue: function (f) {
        const location = this.room.location;
        const stage = location.getContinuousStage(location.stageNo - 1);
        const repairDialogues = bundles.repair_dialogues.jsons.repair_dialogues_data_json.resolve().getJson()[`stage_${stage}`];

        if (repairDialogues && repairDialogues.dialogue) {
            location.showStageDialogue(repairDialogues.dialogue, f);
        } else {
            f();
        }
    },

    onReset: function () {
        this.items.forEach((item, index) => {
            item.setAnimation(0, `idle_${this.getItemStage(index)}`, true);
        });

        this.removeRepairView();
        this.createRepairView();
    },

    onAfterResize: function () {
        this._updateBorders();
    },

    setBorders: function (topBorderHeight, bottomBorderHeight) {
        this.topBorderHeight = topBorderHeight;
        this.bottomBorderHeight = bottomBorderHeight;

        this._updateBorders();
    },

    _updateBorders: function () {
        const bgSize = cleverapps.resolution.getBgSize();
        this.setContentSize(bgSize);

        const topBorder = this.topBorderHeight;
        const bottomBorder = this.bottomBorderHeight;

        const scrollSize = cc.size(bgSize.width, bgSize.height - bottomBorder - topBorder);

        const bgScale = Math.max(scrollSize.width / this.bg.width, scrollSize.height / this.bg.height);

        this.scroll.setContentSize(scrollSize);
        this.scroll.setPosition(this.width / 2, this.scroll.height / 2 + bottomBorder);
        this.scrollContent.setContentSize(this.bg.width * bgScale, this.bg.height * bgScale);
        this.scroll.updateInnerContent();

        this.bg.setPosition(this.scrollContent.width / 2, this.scrollContent.height / 2);
        this.bg.setScale(bgScale);

        if (bottomBorder > 0 || topBorder > 0) {
            this.addBorders(bottomBorder, topBorder);
        } else {
            this.removeBorders();
        }
    },

    updateDynamicPosition: function () {
        this.updateRepairPosition();
    },

    getStateInfo: function () {
        const animations = {};

        Object.values(this.repairs).forEach((animation) => {
            if (!animations[animation]) {
                animations[animation] = 0;
            }

            animations[animation] += 1;
        });

        return Object.keys(animations).map((animation) => `${animation} - ${animations[animation]}`);
    }
});

RepairLocation.prototype.getViewClass = function () {
    return RoomView;
};

cleverapps.styles.RoomView = {
    aroundRectOffset: {
        x: 10,
        y: 10
    },

    repairView: {
        padding: {
            x: 40,
            y: 40
        }
    },

    borders: {
        extraHeight: 6
    }
};
